/* eslint-disable no-param-reassign */
import { GET_ECOMMERCE_PRODUCT_VARIANTS_QUERY } from './querys';

function stripHtml(html) {
  return html
    .replace(/<[^>]+>/g, '')
    .replace(/[\r\n\t]+/g, ' ')
    .trim();
}

function getFrequencyWeeksLabel(unit, frequency) {
  const weeksPerUnit = { Y: 52, Q: 13, M: 4, W: 1 };
  const weeks = (weeksPerUnit[unit] || 1) * (frequency || 1);
  return `${weeks} weeks`;
}

function getPaymentCycleLabel(unit, frequency) {
  // Annual or single-payment-per-cycle → "One-off", anything more frequent → "Recurring"
  if (unit === 'Y' && frequency === 1) return 'One-off';
  return 'Recurring';
}

async function getVariant({ client, currency, id, variantId }) {
  const {
    data: { variants = [] }
  } = await client.query({
    query: GET_ECOMMERCE_PRODUCT_VARIANTS_QUERY,
    variables: { id, currency }
  });

  const variant = variants.find(v => v.variantId === variantId);
  return variant || {};
}

function preparePrice(price) {
  return Number((Math.round(parseFloat(price) * 100) / 100).toFixed(2));
}

async function prepareItemForGtmEvent({ client, currency, gtmItem, item, product }) {
  const { label, name, variantId, sku = '' } = item;

  const variant = await getVariant({ client, currency, id: product.id, variantId });
  const { priceValue = 0, attributes = null } = variant;

  const { name: productName, thirdPartyIdentifier: productThirdPartyIdentifier = '' } = product;
  const variantAttributes = attributes;
  const {
    customFields = {},
    selectedOptions = [],
    thirdPartyIdentifier: variantThirdPartyIdentifier = ''
  } = variantAttributes;

  const pubCode = productThirdPartyIdentifier || sku;
  const offerCode =
    variantThirdPartyIdentifier || pubCode || customFields.oak_current_offer_code || '';
  const pivotalType = customFields.product_type?.includes('subscription')
    ? 'Subscription'
    : 'Single';
  const subscriptionTypeOption = selectedOptions.find(o => o.optionLabel === 'Subscription Type');
  const itemCategory3 = subscriptionTypeOption?.valueName || '';
  gtmItem.id = offerCode;
  gtmItem.item_id = offerCode;
  gtmItem.item_name = `${pubCode} - ${stripHtml(label || name)}`;
  gtmItem.item_brand = productName;
  gtmItem.item_category2 = pivotalType;
  gtmItem.item_category3 = itemCategory3;
  gtmItem.item_category4 = getFrequencyWeeksLabel(
    customFields.oak_payment_frequency_unit,
    customFields.oak_payment_frequency
  );
  gtmItem.item_category5 = getPaymentCycleLabel(
    customFields.oak_payment_frequency_unit,
    customFields.oak_payment_frequency
  );
  gtmItem.item_list_id = customFields.oak_url_name || '';
  gtmItem.item_list_name = productName;
  gtmItem.pivotal_type = pivotalType;
  gtmItem.coupon = '';
  gtmItem.discount = 0;
  gtmItem.price = preparePrice(priceValue);
  gtmItem.quantity = 1;
}

export default prepareItemForGtmEvent;
